
 import adminUrls from "@/urls/admin";
import {
  sendDeleteRequest,
  sendGetRequest,
  sendPatchRequest,
  sendPostRequest
} from "@/helper/requests";
import {executeRequest} from "@/store/modules/utils";
 import {generateListUidToName} from "@/helper/uidToName";

const state = {
  emails: {
    items: [],
    loading: false,
    count: 0,
    detail: [],
    error: null,
  }
};

const getters = {
  getEmails: state => state.emails.items,
  getEmailsCount: state => state.emails.count,
  getCurrentUrl: state => state.emails.currentUrl,
  getEmailsDetail: state => state.emails.detail,
  isLoadingEmails: state => state.emails.loading,
  saveEmailsError: state => state.emails.error,
};

const actions = {
  loadEmailsDetail: ({commit}, {url,id, finalizer=()=>{}, catcher=()=>{}}) => {
    if (!url) url = adminUrls.ADMIN.EMAILS.DETAIL(id)
    sendGetRequest(
        url, (data, url) => {
          commit('SET_EMAILS_DETAIL', data);
          finalizer(data, url);
        }, (data, url) => {
          commit('SAVE_EMAILS_ERROR', data);
          catcher(data, url);
        }
    )
  },
  loadEmailsList: ({commit, getters}, {url, urlAppend, finalizer=()=>{}, catcher=()=>{}}) => {

    if (!url) {
      url = adminUrls.ADMIN.EMAILS.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingEmails) {
      commit('SET_EMAILS_LOADING');
      sendGetRequest(
        url, (data, url) => {
            commit('SET_EMAILS', data['results']);
            commit('SET_EMAILS_COUNT', data['count']);
            commit('SET_EMAILS_LOADING_END');
            finalizer(data, url);
          }, (data, url) => {
            commit('SET_EMAILS_LOADING_END');
            commit('SAVE_EMAILS_ERROR', data);
            catcher(data, url);
        }
      )
    }
  },

  executeEmailResend: ({dispatch, commit, getters}, {id, data, finalizer, catcher}) => {
    let url = adminUrls.ADMIN.EMAILS.RESEND(id)
    executeRequest('Emails', sendPostRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
  },

  createEmails: ({dispatch, commit, getters}, {event,data, finalizer=()=>{}, catcher=()=>{}}) => {
    let url = adminUrls.ADMIN.EMAILS.CREATE(event)
    executeRequest('Emails', sendPostRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
  },
  changeEmails: ({dispatch, commit, getters}, {event,id,data, finalizer,catcher}) => {
    let url = adminUrls.ADMIN.EMAILS.UPEMAILS(event,id)
    executeRequest('Emails', sendPatchRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
  },
  deleteEmails: ({dispatch, commit, getters}, {event,id, finalizer, catcher}) => {
    let url = adminUrls.ADMIN.EMAILS.DELETE(event,id)
    executeRequest('Emails', sendDeleteRequest, {url, finalizer, catcher}, {dispatch, commit, getters});
  },

};

const mutations = {

  SET_EMAILS: (state, obj) => {
    state.emails.items = obj
  },
  SET_EMAILS_DETAIL: (state, value) => {
    state.emails.detail = value
  },
  SET_EMAILS_COUNT: (state, value) => {
    state.emails.count = value
  },
  SET_EMAILS_LOADING: (state) => {
    state.emails.loading = true
  },
  SET_EMAILS_LOADING_END: (state) => {
    state.emails.loading = false
  },
  SAVE_EMAILS_ERROR: (state, error) => {
    state.emails.error = error
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}


